// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1il02","linkContainer":"style_linkContainer__iE2rf","socialIcon":"style_socialIcon__3rsVC"};